import './CardCommon.css';

export default function CardOverview({ header, unit_1, unit_2, unit_3, unit_4, tagname, icon, data_calculation }) {

    const ReadDatatagsProduction = (tagobject, tagname, period, digit, today) => {
        const value = tagobject?.[tagname]?.[period];
        if (value === undefined || value === null) {
            return <div className="measure-cell numberright font-sarabun color-teal number-overview">-</div>
        }

        if ((tagname === 'summary_irr' || tagname === 'summary_ens' || tagname === 'summary_energy') && today !== undefined) {
            let alarmtag = ''
            if (tagname === 'summary_irr') {
                alarmtag = 'error_irr'
            } else if (tagname === 'summary_ens') {
                alarmtag = 'error_ens'
            } else if (tagname === 'summary_energy') {
                alarmtag = 'error_solar'
            }
            if (tagobject[alarmtag] === true) {
                return <div className="measure-cell numberright font-sarabun color-red number-overview">{value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
            } else {
                return <div className="measure-cell numberright font-sarabun color-teal number-overview">{value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
            }
        }
        return <div className="measure-cell numberright font-sarabun color-teal number-overview">{value.toLocaleString('en-US', { minimumFractionDigits: digit, maximumFractionDigits: digit })}</div>
    }

    return (
        <div className='card-overview'>
            <div className="card card-common">
                <div className="card-body d-flex flex-row pb-0 inverter-header py-0 px-0">
                    <div className="d-flex vertical-cardheader-bar">
                        <h5 className="card-title font-weight-bold mb-0"> {header}</h5>
                    </div>
                </div>

                <div className="card-body pb-3 pt-1 pr-0">
                    <div className="d-flex gap-2">
                        <div className="d-block">
                            <div className="overview-icon-box">
                                {icon}
                            </div>
                        </div>
                        <div className="measure-table font-poppins" >
                            <div className="measure-rows">
                                <div className="measure-cell">Today</div>
                                {ReadDatatagsProduction(data_calculation, tagname, "today", 3, true)}
                                <div className="measure-cell measunits">{unit_1}</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell">This Month</div>
                                {ReadDatatagsProduction(data_calculation, tagname, "thismonth", 3)}
                                <div className="measure-cell measunits">{unit_2}</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell">This Year</div>
                                {ReadDatatagsProduction(data_calculation, tagname, "thisyear", 3)}
                                <div className="measure-cell measunits">{unit_3}</div>
                            </div>
                            <div className="measure-rows">
                                <div className="measure-cell">Total</div>
                                {ReadDatatagsProduction(data_calculation, tagname, "total", 3)}
                                <div className="measure-cell measunits">{unit_4}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div>
    )
}
